// @flow

import { graphql } from 'react-relay';
import { ROOT_ID } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation AddShipmentMutation($input: AddShipmentInput!) {
    addShipment(input: $input) {
      shipmentEdge {
        node {
          id
          shipmentNumber
          status
          carrierName
          trackingNumber
          shippingMethod
          shippingAddressLine1
          shippingAddressLine2
          shippingAddressLine3
          shippingAddressCity
          shippingAddressState
          shippingAddressZip
          estimatedShipDate
          actualShipDate
          estimatedDeliveryDate
          actualDeliveryDate
          notes
          order {
            id
            orderNumber
          }
          customer {
            id
            name
          }
          items(first: 1000) {
            edges {
              node {
                id
                quantity
                description
                item {
                  id
                  name
                  itemNumber
                }
                serials {
                  id
                  serialNumber
                }
              }
            }
          }
          updatedAt
          createdAt
        }
      }
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, {
      ...options,
      configs: [
        {
          type: 'RANGE_ADD',
          parentID: ROOT_ID,
          connectionInfo: [
            {
              key: 'PaginatedShipmentsContainer_shipments',
              rangeBehavior: 'prepend',
            },
          ],
          edgeName: 'shipmentEdge',
        },
      ],
    });
  },
};
